import type {CandidateMatchingAction} from 'src/action-creators/candidate-matching';
import type {NodeSchedule} from 'src/types/node-schedule';
import type {GeneratedCriteriaResponse} from 'src/types/candidate-matching';

import {
  RECEIVE_CANDIDATE_MATCHING_INFO,
  UPDATE_CANDIDATE_MATCHING_INFO,
  RESET_CANDIDATE_MATCHING_INFO,
} from 'src/action-creators/candidate-matching';
import {getDefaultNodeScheduleState} from 'src/utils/node-schedule';


export type RadiusUnit = 'MILES' | 'KM';
export type CandidateMatchingState = {
  radiusUnit: RadiusUnit;
  radiusValue: number | null | undefined;
  maxCandidates: number;
  userFilters?: GeneratedCriteriaResponse | null;
} & NodeSchedule;

const initialState = {
  radiusUnit: 'MILES',
  radiusValue: null,
  maxCandidates: 1,
  ...getDefaultNodeScheduleState({}),
} as const;

export default (
  state: CandidateMatchingState = initialState,
  action: CandidateMatchingAction,
): CandidateMatchingState => {
  switch (action.type) {
    case RECEIVE_CANDIDATE_MATCHING_INFO:
      return {
        ...state,
        ...action.payload,
      };
    case UPDATE_CANDIDATE_MATCHING_INFO:
      return {
        ...state,
        ...action.payload,
      };
    case RESET_CANDIDATE_MATCHING_INFO:
      return {...initialState};
  }
  return state;
};
